<template>
  <div class="card-item-count">
    <div class="label">
      <span>{{ label }}</span>
    </div>
    <div class="value">
      <span>{{ value ? value : 0 }}</span>
      <span class="small">{{ hint }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: [String],
    },
    hint: {
      type: [String],
    },
    value: {
      type: [String, Number],
    },
  },
};
</script>

<style lang="scss">
.card-item-count {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  width: 15rem;
  background-color : rgb($color-primary-rgb, .1);
  font-weight: 600;
  gap: 1rem;
  border-radius: 10px;
  box-shadow: 0 0 3px #e3dada;
  .label {
    width: 100%;
    color: $color-secondary;
    font-size: 1.2em;
  }
  .value {
    font-weight: 600;
    font-size: 2em;
    color: $color-secondary;

    .small {
      font-size: 0.5em;
    }
  }
}
</style>
